/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ContractNoticeTagRequest {
    dataIds: Array<string>;
    tagIds: Array<string>;
    /** Hand-added (autotag UI, no live /api-docs yet). Backend already reads this field. */
    userReason?: string;
    /** Hand-added (autotag UI, no live /api-docs yet). Free text on the backend (VARCHAR(30)) - the fixed 5-code list lives in the frontend only. */
    reasonCode?: string;
}